import { SVGProps } from "react";

const IconDashboard = (props: SVGProps<SVGSVGElement>) => {
    const { className, ...rest } = props;

    return (
        <svg
            className={className}
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            {...rest}
        >
            <path
                d="M2.74219 16.7634C2.74219 16.2111 3.1899 15.7634 3.74219 15.7634H5.24219C5.79447 15.7634 6.24219 16.2111 6.24219 16.7634V18.2906C6.24219 18.8429 5.79447 19.2906 5.24219 19.2906H3.74219C3.1899 19.2906 2.74219 18.8429 2.74219 18.2906V16.7634Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M9.23047 12.7537C9.23047 12.2014 9.67818 11.7537 10.2305 11.7537H11.7305C12.2828 11.7537 12.7305 12.2014 12.7305 12.7537V18.2906C12.7305 18.8429 12.2828 19.2906 11.7305 19.2906H10.2305C9.67818 19.2906 9.23047 18.8429 9.23047 18.2906V12.7537Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M15.75 8.71558C15.75 8.16329 16.1977 7.71558 16.75 7.71558H18.25C18.8023 7.71558 19.25 8.16329 19.25 8.71558V18.2905C19.25 18.8428 18.8023 19.2905 18.25 19.2905H16.75C16.1977 19.2905 15.75 18.8428 15.75 18.2905V8.71558Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <circle
                cx="17.5"
                cy="2.99072"
                r="1.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <circle
                cx="11"
                cy="7.00439"
                r="1.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <circle
                cx="4.49219"
                cy="11"
                r="1.25"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M12.3758 6.26194L16.0957 3.90186"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M9.38477 8.16602L6.12126 10.2366"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default IconDashboard;
